import React, { useState, useEffect } from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import CodeIcon from '@mui/icons-material/Code';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import meImage from '../assets/images/me.jpeg';
import '../assets/styles/Main.scss';

const titles = [
    "Full Stack Engineer",
    "GenAI Enthusiast",
    "DevOps Specialist",
    "System Architect"
];

function Main() {
    const [titleIndex, setTitleIndex] = useState(0);
    const [charIndex, setCharIndex] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [typedTitle, setTypedTitle] = useState("");

    useEffect(() => {
        const currentTitle = titles[titleIndex];

        const timeout = setTimeout(() => {
            if (!isDeleting) {
                if (charIndex < currentTitle.length) {
                    setTypedTitle(currentTitle.substring(0, charIndex + 1));
                    setCharIndex(charIndex + 1);
                } else {
                    setTimeout(() => setIsDeleting(true), 2500);
                }
            } else {
                if (charIndex > 0) {
                    setTypedTitle(currentTitle.substring(0, charIndex - 1));
                    setCharIndex(charIndex - 1);
                } else {
                    setIsDeleting(false);
                    setTitleIndex((prev) => (prev + 1) % titles.length);
                }
            }
        }, isDeleting ? 30 : 80);

        return () => clearTimeout(timeout);
    }, [charIndex, isDeleting, titleIndex]);

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <div className="container">
            <div className="ambient-glow-1"></div>
            <div className="ambient-glow-2"></div>
            
            <section className="about-section">
                <div className="content-wrapper">
                    
                    {/* Left Column: Content */}
                    <div className="hero-content">
                        <div className="badge-glass">
                            <span className="status-dot"></span>
                            <span>Available for new opportunities</span>
                        </div>

                        <h1>
                            Hello, I'm <br />
                            <span className="gradient-text">Ayman Haider</span>
                        </h1>

                        <div className="title-wrapper">
                            <span className="typing-text">
                                {typedTitle}
                                <span className="cursor"></span>
                            </span>
                        </div>

                        <p className="description">
                            I architect and build scalable web applications and intelligent systems. 
                            Passionate about clean code, DevOps automation, and leveraging AI 
                            to solve complex real-world problems.
                        </p>

                        <div className="action-group">
                            <button className="btn-glass primary" onClick={() => scrollToSection("projects")}>
                                Explore Work
                            </button>
                            <button className="btn-glass secondary" onClick={() => scrollToSection("contact")}>
                                Let's Talk
                            </button>
                            
                            <div className="social-icons-glass">
                                <a href="https://github.com/elmosuy" target="_blank" rel="noreferrer" aria-label="GitHub">
                                    <GitHubIcon />
                                </a>
                                <a href="https://www.linkedin.com/in/elmosuy/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                                    <LinkedInIcon />
                                </a>
                                <a href="mailto:elmosuy@gmail.com" aria-label="Email">
                                    <EmailIcon />
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Right Column: Visual */}
                    <div className="hero-visual">
                        <div className="glass-card-image">
                            <div className="image-inner">
                                <img src={meImage} alt="Ayman Haider" />
                            </div>
                            
                            {/* Floating Glass Stats */}
                            <div className="floating-stat stat-1">
                                <div className="stat-icon">
                                    <CodeIcon />
                                </div>
                                <div className="stat-info">
                                    <span className="stat-value">50+</span>
                                    <span className="stat-label">Projects</span>
                                </div>
                            </div>

                            <div className="floating-stat stat-2">
                                <div className="stat-icon">
                                    <AutoGraphIcon />
                                </div>
                                <div className="stat-info">
                                    <span className="stat-value">6+</span>
                                    <span className="stat-label">Years Exp</span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="scroll-indicator">
                    <span>Scroll Down</span>
                    <div className="mouse"></div>
                </div>
            </section>
        </div>
    );
}

export default Main;
